import { render, staticRenderFns } from "./NavegationMobile.vue?vue&type=template&id=8754d67e&scoped=true"
import script from "./NavegationMobile.vue?vue&type=script&lang=js"
export * from "./NavegationMobile.vue?vue&type=script&lang=js"
import style0 from "./NavegationMobile.vue?vue&type=style&index=0&id=8754d67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8754d67e",
  null
  
)

export default component.exports